import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseContainer, BaseDesc, BaseTitle,
} from './styles';

const vPadding = 140;
const Container = styled(BaseContainer)`
  ${props => (props.theme.isMobile ? `
    align-items: center;
    margin-top: 35px;
  ` : `
    align-items: left;
    margin-top: ${vPadding + 8}px;
    margin-bottom: ${vPadding + 8}px;
  `)};

  & > .right {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    ${props => (props.theme.isMobile ? `
      order: 1;
      width: auto;
      margin-left: -20px;
      margin-right: -20px;
    ` : `
      order: 3;
      margin-left: -40px;
      margin-top: -40px;
      top: -23px;
      max-width: 560px;
      min-width: 540px;
      width: 44vw;
      padding-left: 4vw;
    `)};
  }
`;

const Box = styled.div`
  position: relative;
  padding: 0px 10px;
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 20px -8px ${props => props.theme.secondaryColor};
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  ${props => (props.theme.isMobile ? `
    width: 39vw;
    min-width: 146px;
    height: 31vw;
    min-height: 116px;
    margin: 20px;
  ` : `
    margin-left: 40px;
    margin-top: 40px;
    width: 196px;
    height: 156px;
  `)};
`;

const BoxTitle = styled.div`
  margin-top: 23px;
  margin-bottom: 18px;
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  text-align: center;
  ${props => (props.theme.isMobile ? `
    font-size: 29px;
    line-height: 37px;
  ` : `
    font-size: 39px;
    line-height: 51px;
  `)};

  :after {
    content: '%';
    font-size: 50%;
    position: absolute;
    top: 16px;
  }
`;

const BoxDesc = styled(SectionName)`
  font-size: ${props => (props.theme.isMobile ? 13 : 18)}px;
`;

export default function AudienceEngagement() {
  const { isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#audience-engagement-container', vPadding);

  return (
    <Container id="audience-engagement-container">
      <Plx className="left-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionName>Solutions</SectionName>
        <BaseTitle>Engage the right audience ready to make decisions</BaseTitle>
        <BaseDesc>
          89% of our readers are actively seeking investments.
          Livewire attracts serious investors and advisers who are
          actively looking for investment opportunities.
        </BaseDesc>
      </Plx>
      <Plx className="right" parallaxData={plxData.image} disabled={isMobile}>
        <Box>
          <BoxTitle>47</BoxTitle>
          <BoxDesc>self directed investors</BoxDesc>
        </Box>
        <Box>
          <BoxTitle>21</BoxTitle>
          <BoxDesc>sophisticated &amp; family office</BoxDesc>
        </Box>
        <Box>
          <BoxTitle>20</BoxTitle>
          <BoxDesc>
            Advisors &amp;
            <br />
            Wealth managers
          </BoxDesc>
        </Box>
        <Box>
          <BoxTitle>12</BoxTitle>
          <BoxDesc>funds &amp; institutions</BoxDesc>
        </Box>
      </Plx>
    </Container>
  );
}
